import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, MapPin, Github, Linkedin, ArrowRight } from 'lucide-react';
import { content } from '../config/content';
import Logo from './Logo';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="md:col-span-1">
            <Link to="/" className="inline-block mb-4">
              <Logo />
            </Link>
            <p className="text-gray-400 text-sm mb-6">
              Building production-ready software with modern tech and AI-powered development.
            </p>
            <div className="flex space-x-4">
              <a
                href="https://github.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center text-gray-400 hover:text-white hover:bg-white/20 transition-all"
              >
                <Github size={18} />
              </a>
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center text-gray-400 hover:text-white hover:bg-white/20 transition-all"
              >
                <Linkedin size={18} />
              </a>
              <a
                href={`mailto:${content.company.email}`}
                className="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center text-gray-400 hover:text-white hover:bg-white/20 transition-all"
              >
                <Mail size={18} />
              </a>
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-gray-300 mb-4">Navigation</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/portfolio" className="text-gray-400 hover:text-white transition-colors">
                  Portfolio
                </Link>
              </li>
              <li>
                <Link to="/solutions" className="text-gray-400 hover:text-white transition-colors">
                  Services
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-gray-300 mb-4">Contact</h4>
            <div className="space-y-3">
              <div className="flex items-center gap-3 text-gray-400">
                <Mail className="w-4 h-4 text-[#0088cc]" />
                <a href={`mailto:${content.company.email}`} className="hover:text-white transition-colors">
                  {content.company.email}
                </a>
              </div>
              <div className="flex items-center gap-3 text-gray-400">
                <MapPin className="w-4 h-4 text-[#0088cc]" />
                <span>{content.company.address.state}, USA</span>
              </div>
            </div>
          </div>

          {/* CTA */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-gray-300 mb-4">Start a Project</h4>
            <p className="text-gray-400 text-sm mb-4">
              Have an idea? Let's turn it into reality.
            </p>
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 px-5 py-2.5 bg-[#0088cc] text-white text-sm rounded-lg hover:bg-[#006699] transition-colors font-medium"
            >
              Get in Touch
              <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="text-gray-400 text-sm flex items-center gap-2">
              © {new Date().getFullYear()} {content.company.name}. All rights reserved.
              {/* Hidden admin access - looks like a decorative dot */}
              <Link
                to="/admin/login"
                className="w-1.5 h-1.5 rounded-full bg-gray-700 hover:bg-[#0088cc] transition-colors ml-1"
                title=""
                aria-label="Admin"
              />
            </div>
            <div className="flex gap-6 text-sm">
              <Link to="/portfolio" className="text-gray-400 hover:text-white transition-colors">
                View My Work
              </Link>
              <Link to="/contact" className="text-gray-400 hover:text-white transition-colors">
                Contact
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
